import { render, staticRenderFns } from "./DashboardManager.vue?vue&type=template&id=6fbffdfe&"
import script from "./DashboardManager.vue?vue&type=script&lang=js&"
export * from "./DashboardManager.vue?vue&type=script&lang=js&"
import style0 from "./DashboardManager.vue?vue&type=style&index=0&id=6fbffdfe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports